export const TIMELINE_TYPE = {
  APPOINTMENT_ANNOTATION: 'APPOINTMENT_ANNOTATION',
  APPOINTMENT_ANNOTATION_HEALTH_COMMUNITY:
    'APPOINTMENT_ANNOTATION_HEALTH_COMMUNITY',
  APPOINTMENT_ASSISTANCE_CARE: 'APPOINTMENT_ASSISTANCE_CARE',
  APPOINTMENT_DEFAULT: 'APPOINTMENT_DEFAULT',
  APPOINTMENT_FOLLOW_UP_VISIT: 'APPOINTMENT_FOLLOW_UP_VISIT',
  APPOINTMENT_IMMERSION: 'APPOINTMENT_IMMERSION',
  APPOINTMENT_HEALTH_PLAN_CARE: 'APPOINTMENT_HEALTH_PLAN_CARE',
  APPOINTMENT_ON_SITE: 'APPOINTMENT_ON_SITE',
  APPOINTMENT_STATEMENT_OF_HEALTH: 'APPOINTMENT_STATEMENT_OF_HEALTH',
  APPOINTMENT_TEST_COLLECT: 'APPOINTMENT_TEST_COLLECT',
  THIRD_PARTY_APPOINTMENT_EMERGENCY: 'THIRD_PARTY_APPOINTMENT_EMERGENCY',
  THIRD_PARTY_APPOINTMENT_HOSPITALIZATION:
    'THIRD_PARTY_APPOINTMENT_HOSPITALIZATION',
  TIT_EMERGENCY: 'TIT_EMERGENCY',
  TIT_HOSPITALIZATION: 'TIT_HOSPITALIZATION',
  TIT_SURGERY: 'TIT_SURGERY',
  APPOINTMENT_COMMUNITY: 'APPOINTMENT_COMMUNITY',
  HEALTH_FORM_ANSWER_GROUP: 'HEALTH_FORM_ANSWER_GROUP',
  CLINICAL_RECORD: 'CLINICAL_RECORD',
  REFUND_APPOINTMENT: 'REFUND_APPOINTMENT'
}

export const TIMELINE_ITEMS = {
  [TIMELINE_TYPE.APPOINTMENT_ANNOTATION]: {
    component: 'components/timeline/organisms/cardItems/TIClinicalRecord',
    label: 'Anotação',
    icon: 'icPaper'
  },
  [TIMELINE_TYPE.APPOINTMENT_ANNOTATION_HEALTH_COMMUNITY]: {
    component: 'components/timeline/organisms/cardItems/TIClinicalRecord',
    label: 'Matriciamento',
    icon: 'icPaper'
  },
  [TIMELINE_TYPE.APPOINTMENT_ASSISTANCE_CARE]: {
    component: 'components/timeline/organisms/cardItems/TIClinicalRecord',
    label: 'Atendimento Alice Agora',
    icon: 'icHeartOutlined'
  },
  [TIMELINE_TYPE.APPOINTMENT_DEFAULT]: {
    component: 'components/timeline/organisms/cardItems/TIClinicalRecord',
    label: 'Consulta',
    icon: 'icHouse'
  },
  [TIMELINE_TYPE.APPOINTMENT_FOLLOW_UP_VISIT]: {
    component: 'components/timeline/organisms/cardItems/TIClinicalRecord',
    label: 'Retorno',
    icon: 'icHouse'
  },
  [TIMELINE_TYPE.APPOINTMENT_HEALTH_PLAN_CARE]: {
    component: 'components/timeline/organisms/cardItems/TIClinicalRecord',
    label: 'Atendimento Enfermeiras Gestoras',
    icon: 'icHeartOutlined'
  },
  [TIMELINE_TYPE.APPOINTMENT_IMMERSION]: {
    component: 'components/timeline/organisms/cardItems/TIClinicalRecord',
    label: 'Imersão',
    icon: 'icHouse'
  },
  [TIMELINE_TYPE.APPOINTMENT_ON_SITE]: {
    component: 'components/timeline/organisms/cardItems/TIClinicalRecord',
    label: 'On Site',
    icon: 'icHouse'
  },
  [TIMELINE_TYPE.APPOINTMENT_STATEMENT_OF_HEALTH]: {
    component: 'components/timeline/organisms/cardItems/TIClinicalRecord',
    label: 'Declaração de Saúde',
    icon: 'icCell'
  },
  [TIMELINE_TYPE.APPOINTMENT_TEST_COLLECT]: {
    component: 'components/timeline/organisms/cardItems/TIClinicalRecord',
    label: 'Atendimento Casa Alice',
    icon: 'icLab'
  },
  [TIMELINE_TYPE.THIRD_PARTY_APPOINTMENT_EMERGENCY]: {
    component:
      'components/timeline/organisms/cardItems/TIThirdPartyAppointment',
    label: 'Pronto socorro',
    icon: 'icAlertRotatinLight'
  },
  [TIMELINE_TYPE.THIRD_PARTY_APPOINTMENT_HOSPITALIZATION]: {
    component:
      'components/timeline/organisms/cardItems/TIThirdPartyAppointment',
    label: 'Internação',
    icon: 'icHospital'
  },
  [TIMELINE_TYPE.TIT_EMERGENCY]: {
    component: 'components/timeline/organisms/cardItems/TITEmergency',
    label: 'Pronto socorro',
    icon: 'icAlertRotatinLight'
  },
  [TIMELINE_TYPE.TIT_HOSPITALIZATION]: {
    component: 'components/timeline/organisms/cardItems/TITHospitalization',
    label: 'Internação',
    icon: 'icHospital'
  },
  [TIMELINE_TYPE.TIT_SURGERY]: {
    component: 'components/timeline/organisms/cardItems/TITSurgery',
    label: 'Cirurgia',
    icon: 'icHospital'
  },
  [TIMELINE_TYPE.APPOINTMENT_COMMUNITY]: {
    component: 'components/timeline/organisms/cardItems/TICounterReferral',
    label: 'Contrarreferências',
    icon: 'icStethoscope'
  },
  [TIMELINE_TYPE.HEALTH_FORM_ANSWER_GROUP]: {
    component: 'components/timeline/organisms/cardItems/TIHealthForm',
    label: 'Questionário',
    icon: 'icScript'
  },
  [TIMELINE_TYPE.CLINICAL_RECORD]: {
    component: 'components/timeline/organisms/cardItems/TIClinicalRecord',
    label: 'Registro clínico',
    icon: 'icPaper'
  },
  [TIMELINE_TYPE.REFUND_APPOINTMENT]: {
    component:
      'components/timeline/organisms/cardItems/TIRefundCounterReferral',
    label: 'Contrarreferência de Reembolso',
    icon: 'icRefundMoney'
  }
}

export const TIMELINE_STATUS = {
  DRAFT: 'DRAFT',
  FINISHED: 'FINISHED',
  DISCARDED_NO_SHOW: 'DISCARDED_NO_SHOW'
}

export const TIMELINE_PHYSICIAN_TYPE = {
  STAFF: 'STAFF',
  SPECIALIST: 'SPECIALIST'
}

export const TIMELINE_PHYSICIAN_TYPE_LABEL = {
  [TIMELINE_PHYSICIAN_TYPE.STAFF]: 'Staff',
  [TIMELINE_PHYSICIAN_TYPE.SPECIALIST]: 'Especialista'
}

export const TIMELINE_REFERENCED_LINK_TYPE = {
  SPECIALIST_OPINION: 'SPECIALIST_OPINION'
}

export const TIMELINE_EVENT_OPTIONS = [
  {
    value: 'EMERGENCY_ROOM',
    name: 'Pronto socorro'
  },
  {
    value: 'HOSPITALIZATION',
    name: 'Internação'
  },
  {
    value: 'SURGERY',
    name: 'Cirurgia'
  }
]

export const TIMELINE_TAGS = {
  [TIMELINE_STATUS.DRAFT]: {
    type: 'DRAFT',
    label: 'Rascunho',
    color: 'gray'
  },
  [TIMELINE_STATUS.DISCARDED_NO_SHOW]: {
    type: 'NO_SHOW',
    label: 'No Show',
    color: 'magenta'
  },
  SECOND_OPINION: {
    type: 'SECOND_OPINION',
    label: 'Opinião de especialista',
    color: 'violet'
  },
  SERVICED_BY_YOU: {
    type: 'SERVICED_BY_YOU',
    label: 'Atendido por você',
    color: 'blue'
  },
  AI_GENERATED: {
    type: 'AI_GENERATED',
    label: 'Gerado por IA',
    color: 'gray',
    icon: 'icMagic'
  }
}

export const AI_REVIEW = {
  NOT_REVIEWED: 'NOT_REVIEWED',
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE'
}
